<template>
  <div>
    <sistema>
      <div class="acesso-negado">
        <h3>Acesso não autorizado</h3>
        <p>
          Esta funcionalidade não está habilitada para o seu cliente. Entre em
          contato com o suporte caso acredite que isso seja um engano.
        </p>
      </div>
    </sistema>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {}
})
export default class AcessoNegado extends Vue {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
